;(function (featureFlags) {
  "use strict"

  function amplitudeFeatureFlagIdentify() {
    if (featureFlags) {
      const identity = new amplitude.Identify()

      Object.keys(featureFlags).forEach((flagName) => {
        identity.set(flagName, `${featureFlags[flagName]}`)
      })

      amplitude.getInstance().identify(identity)
    }
  }

  if (typeof amplitude !== "undefined") {
    amplitudeFeatureFlagIdentify()
  }
})(window.feature_flags)
